import FJButton, { FJButtonType } from '../../common/components/FJButton/FJButton';
import FJOopsSvg from '../../assets/oops.svg?react';
import FJLocalStore from '../../store/FJLocalStore';
import styles from './FJFailedPage.module.less';

interface FJFailedPageProps {
    onTryAgain?: () => void;
    onBack?: () => void;
    /** 为 false 时不展示「重试」按钮（如 NO_TRANSCRIPTION / NO_HIGHLIGHTS_DETECTED） */
    showTryAgain?: boolean;
    titleKey?: string;
    descKey?: string;
}

export default function FJFailedPage({
    onTryAgain,
    onBack,
    showTryAgain = true,
    titleKey = 'video-generation-failed',
    descKey = 'this-task-failed-due-to-network-fluctuations-or-service-overload-please-try-again-later',
}: FJFailedPageProps) {
    return (
        <div className={styles.root}>
            <div className={styles.content_wrap}>
                <FJOopsSvg className={styles.oops_svg} aria-hidden />

                <h1 className={styles.title}>{FJLocalStore._(titleKey)}</h1>
                <p className={styles.desc}>{FJLocalStore._(descKey)}</p>

                <div className={styles.actions}>
                    <FJButton type={FJButtonType.DEFAULT} className={styles.back_btn} text='back' onClick={onBack} />
                    {showTryAgain ? (
                        <FJButton
                            type={FJButtonType.GRADIENT}
                            className={styles.try_btn}
                            text='try-again'
                            onClick={onTryAgain}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
}
